import { Directive, ElementRef, HostBinding, Input, Optional } from "@angular/core";

import { ButtonLikeAbstraction } from "../shared/button-like.abstraction";

import { PrefixClasses, prefixContentClasses } from "./prefix.directive";

@Directive({
  selector: "[bitSuffix]",
})
export class BitSuffixDirective {
  constructor(
    private elementRef: ElementRef<HTMLElement>,
    @Optional() private buttonComponent: ButtonLikeAbstraction,
  ) {}

  @HostBinding("class") @Input() get classList() {
    return PrefixClasses.concat(["tw-border-none"]).concat(
      prefixContentClasses(this.elementRef.nativeElement, this.buttonComponent),
    );
  }

  ngOnInit(): void {
    this.buttonComponent?.setButtonType("unstyled");
  }
}
